module.exports = __webpack_public_path__ + "b8a1f7bf8d9755720bbdf809cbc2df20.png";